module.exports = __webpack_public_path__ + "img/20190614162158012.0f0ce79b.png";